var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSell = function SvgIconSell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.412 5.4103C12.1494 5.14767 11.7933 5.00008 11.422 5H6.40034C6.02895 5 5.67277 5.14754 5.41015 5.41015C5.14754 5.67277 5 6.02895 5 6.40034V11.422C5.00008 11.7933 5.14767 12.1494 5.4103 12.412L11.5046 18.5063C11.8228 18.8225 12.2532 19 12.7019 19C13.1505 19 13.5809 18.8225 13.8992 18.5063L18.5063 13.8992C18.8225 13.5809 19 13.1505 19 12.7019C19 12.2532 18.8225 11.8228 18.5063 11.5046L12.412 5.4103Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    transform: "matrix(1 0 0 -1 8 10)",
    fill: "black"
  })));
};
export default SvgIconSell;